import { Users } from "lucide-react"

export default function StepsSection() {
    return (
        <section className="py-20">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                <div className="rounded-3xl bg-gradient-to-r from-[#1b237a] to-[#1a2a8f] px-6 sm:px-10 lg:px-12 py-16 lg:py-20 text-white">

                    {/* Heading */}
                    <div className="text-center max-w-3xl mx-auto mb-16">
                        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold leading-tight">
                            Simple <span className="text-cyan-400">Steps</span>, Limitless Possibilities
                        </h2>
                        <p className="mt-4 text-sm sm:text-base text-white/70 leading-relaxed">
                            With concepts in hand, we meticulously design, refining every
                            detail to align with your vision and objectives.
                        </p>
                    </div>

                    {/* Steps */}
                    <div className="relative grid grid-cols-1 md:grid-cols-3 gap-10 lg:gap-12">

                        {/* Step 1 */}
                        <div className="relative">
                            <div className="pl-16 sm:pl-20">
                                <span className="absolute left-0 top-0 text-6xl sm:text-7xl lg:text-8xl font-bold text-white/10 leading-none">
                                    01
                                </span>
                                <h3 className="text-lg sm:text-xl font-semibold mb-3">
                                    Register your company
                                </h3>
                                <p className="text-sm sm:text-base text-white/70 leading-relaxed">
                                    They may offer a range of services, from project-based work to
                                    ongoing support and maintenance.
                                </p>
                                <Users className="mt-6 h-8 w-8 sm:h-10 sm:w-10 text-cyan-400" />
                            </div>
                        </div>

                        {/* Divider 1 */}
                        <div className="hidden md:block absolute left-1/3 top-0 bottom-0 w-px bg-white/15 -translate-x-1/2" />

                        {/* Step 2 */}
                        <div className="relative">
                            <div className="pl-16 sm:pl-20">
                                <span className="absolute left-0 top-0 text-6xl sm:text-7xl lg:text-8xl font-bold text-white/10 leading-none">
                                    02
                                </span>
                                <h3 className="text-lg sm:text-xl font-semibold mb-3">
                                    Configure settings
                                </h3>
                                <p className="text-sm sm:text-base text-white/70 leading-relaxed">
                                    They may offer a range of services, from project-based work to
                                    ongoing support and maintenance.
                                </p>
                                <Users className="mt-6 h-8 w-8 sm:h-10 sm:w-10 text-cyan-400" />
                            </div>
                        </div>

                        {/* Divider 2 */}
                        <div className="hidden md:block absolute left-2/3 top-0 bottom-0 w-px bg-white/15 -translate-x-1/2" />

                        {/* Step 3 */}
                        <div className="relative">
                            <div className="pl-16 sm:pl-20">
                                <span className="absolute left-0 top-0 text-6xl sm:text-7xl lg:text-8xl font-bold text-white/10 leading-none">
                                    03
                                </span>
                                <h3 className="text-lg sm:text-xl font-semibold mb-3">
                                    Start managing
                                </h3>
                                <p className="text-sm sm:text-base text-white/70 leading-relaxed">
                                    They may offer a range of services, from project-based work to
                                    ongoing support and maintenance.
                                </p>
                                <Users className="mt-6 h-8 w-8 sm:h-10 sm:w-10 text-cyan-400" />
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    )
}
